import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcHeaderLanguageSelector from '@shared/layouts/components/header/header-language-selector.vue';

@Component({
  name: 'bpc-confirm-account',
  components: {
    BpcHeaderLanguageSelector,
  },
})
export default class ConfirmAccount extends Vue {
  // @Prop(String) readonly tenantAlias: string;
  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }
  accountConfirmed: boolean = false;
  confirmingAccount: boolean = true;
  showAlertSuccess: boolean = false;
  showAlertDanger: boolean = false;
  alertMessage: string = '';
  defaultBackground: string = 'background-color: rgba(15, 58, 93, 0.85)';

  get background() {
    return this.tenantBackground
      ? `background-image: url("${this.tenantBackground}")`
      : this.defaultBackground;
  }

  get logo() {
    return `background-image: url("${this.tenantLogo}")`;
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get token() {
    return this.$route.query.token ? this.$route.query.token : null;
  }

  get profile() {
    return this.$route.query.profile ? this.$route.query.profile : null;
  }

  get confirmPath() {
    return `auth/${this.tenantAlias}/${this.lang}/confirm-account`;
  }

  showAlert(status, message) {
    this.alertMessage = message;
    this.showAlertSuccess = status === 'success';
    this.showAlertDanger = status === 'danger';
  }

  hideAlert() {
    this.alertMessage = '';
    this.showAlertSuccess = false;
    this.showAlertDanger = false;
  }

  async beforeMount() {
    if (!this.selectedUserLang && this.lang !== this.defaultLanguage) {
      await this.translationService.getTranslations(this.defaultLanguage);
    }
  }

  mounted() {
    this.$bpcApi
      .post(`${this.confirmPath}`, {
        profile: this.profile,
        token: this.token,
      })
      .subscribe(
        res => {
          this.confirmingAccount = false;
          this.accountConfirmed = true;
          this.showAlert('success', res.data.message);
        },
        error => {
          this.confirmingAccount = false;
          this.showAlert('danger', this.$t('global.error_confirming_account'));
        },
      );
  }

  get settingsLoaded() {
    return !this.$store.getters['centerSettings/isLoading'];
  }

  get availableLanguages() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].available_languages;
    }
    return null;
  }

  get selectedUserLang() {
    return this.$store.getters['auth/userLang'];
  }

  get defaultLanguage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/defaultLanguage'];
    }
    return null;
  }

  get tenantBackground() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].background
    ) {
      let background = this.$store.getters['centerSettings/centerSettings'].background;
      if (typeof background === 'string') {
        background = JSON.parse(background);
      }
      return background.url;
    }
    return null;
  }

  get tenantLogo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (logo && typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }
}
